import { createQueryKeys } from '@lukemorales/query-key-factory'

export const network = createQueryKeys('network', {
  list: (userId?: number, query?: string) => [userId, query],
})
